import * as Sentry from '@sentry/react'
import { initializeApp } from 'firebase/app'
import { initializeFirestore, memoryLocalCache } from 'firebase/firestore'
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyDJ6j0OPSUZIPFcrQ17li4k0hR4oAe5otg',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'desres-kitchen-v2.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'desres-kitchen-v2',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'desres-kitchen-v2.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '1095571726377',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:1095571726377:web:b2c7b08e1f0a269104bc38',
}

const app = initializeApp(firebaseConfig)

// Memory-only cache — no IndexedDB persistence.
// Prevents stale offline state from corrupted IndexedDB.
// App uses localStorage as primary store, so Firestore persistence is not needed.
//
// Transport: forced long polling. autoDetectLongPolling was tried but
// caused Firebase Auth errors on mobile — reverted. The waitForAuth /
// AuthContext / App.jsx loading-screen timeouts handle the indefinite
// hang case at the application layer instead.
export const db = initializeFirestore(app, {
  localCache: memoryLocalCache(),
  experimentalForceLongPolling: true,
  useFetchStreams: false,
})

export const auth = getAuth(app)

// Pin Auth to localStorage instead of IndexedDB.
// This sidesteps iOS IndexedDB quirks and the Firestore cache wipe below.
// browserLocalPersistence uses window.localStorage, not IndexedDB.
setPersistence(auth, browserLocalPersistence).catch(err => {
  console.warn('[auth] Failed to set persistence:', err?.message)
})

// Wipe any leftover Firestore IndexedDB databases on load
if (typeof window !== 'undefined' && window.indexedDB?.databases) {
  window.indexedDB.databases().then(dbs => {
    for (const d of dbs) {
      // Only delete Firestore cache DBs — never Auth persistence DBs.
      // Firestore IndexedDB names start with 'firestore/' prefix.
      // Firebase Auth uses 'firebaseLocalStorageDb' — must NOT be deleted.
      if (d.name && d.name.startsWith('firestore/')) {
        window.indexedDB.deleteDatabase(d.name)
      }
    }
  }).catch(err => {
    console.warn('[firebase] IndexedDB wipe failed:', err?.message)
    Sentry.captureException(err, { extra: { fn: 'firebase.wipeFirestoreDBs' } })
  })
}

export default app
